import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "16px",
	height: "16px",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Wireframes-Web-Customer-Yulia",
		stroke: "none",
		strokeWidth: 1,
		fill: "current",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Desktop---Dark---Customer---Docs",
			transform: "translate(-22.000000, -25.000000)",
			children: /* @__PURE__ */ _jsx("polygon", {
				id: "Shape",
				points: "38 32 25.8 32 31.4 26.4 30 25 22 33 30 41 31.4 39.6 25.8 34 38 34"
			})
		})
	})
});
export default SvgArrowBack;
